class NcmInconsistenteController extends AbstractController
  @$inject = ['$injector', '$scope', 'pathService', 'ncmInconsistenteService']

  constructor: ($injector, @scope, pathService, @ncmInconsistenteService) ->
    super($injector)

    @loadingTracker = @promiseTracker()
    url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/ncm-inconsistente/"
    @modalNcmInconsistente = @openPopup(url + "modal.html", 'ncmInconsistenteModalController as ctrl')

    @listOfNcmInconsistente = []

    @filtro =
      descricao: ''
      pendente: true

    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @loadData()

  loadData: (page = 1) ->
    filtro = angular.copy @filtro
    filtro.page = page

    @loadingTracker.addPromise @ncmInconsistenteService.getList(filtro, (result) =>
      if result.success
        @listOfNcmInconsistente = result.data.items

        @pagination =
          page: filtro.page
          totalPages: result.data.totalPages
          perPage: 1
      else
        @Alert.error('Ocorreu um erro ao buscar lista de exceções.', 'Erro!', false)
    )

  detalhes: (ncmInconsistente) ->
    @modalNcmInconsistente({ncmInconsistente: -> ncmInconsistente}, (result) =>
      if result.ok
        item = @listOfNcmInconsistente.select( (item) ->
          return item.dados.id == result.data.id
        ).first()
        item.dados = result.data
    )

class NcmInconsistenteModalController extends AbstractController
  @$inject = ['$injector', 'gql', 'ncmInconsistenteService', '$uibModalInstance', 'ncmInconsistente']

  constructor: ($injector, @gql, @ncmInconsistenteService, @modalInstance, ncmInconsistente) ->
    super($injector)

    @submitTracker = @promiseTracker()

    @ncmInconsistente = angular.copy ncmInconsistente.dados
    @ncm = angular.copy ncmInconsistente.ncm

    @status = @ncmInconsistente.status

  send: (status, $event) ->
    @ncmInconsistente.status = status

    options =
      clickEvent: $event,
      loadingText: if status then 'Confirmando...' else 'Negando...',

    @submitTracker.addPromise @ncmInconsistenteService.save(@ncmInconsistente, (data) =>
      @gql.mutate(gql(["mutation ($ncm: String!, $codigoBarras: String) {
        deleteAuditoriasContinuas(ncm: $ncm, codigoBarras: $codigoBarras)
      }"]), { ncm: @ncmInconsistente.ncm, codigoBarras: @ncmInconsistente.codigoBarras })

      Alert.success("Condição proposta Nº <strong>#{@ncmInconsistente.id}</strong> <u>#{if @ncmInconsistente.status == 'confirmado' then 'confirmada' else 'negada'}</u> com sucesso.", 'Sucesso!')

      @modalInstance.close(new Retorno(true, null, data))
    , options)

  confirmar: ($event) ->
    @send('confirmado', $event)

  negar: ($event) ->
    @send('negado', $event)

angular.module('eficienciaFiscalModule').controller('ncmInconsistenteController', NcmInconsistenteController)
angular.module('eficienciaFiscalModule').controller('ncmInconsistenteModalController', NcmInconsistenteModalController)
